import styles from './CodeBlock.module.css';

export interface CodeBlockProps {
  children: string;
  className?: string;
}

export function CodeBlock({ children, className }: CodeBlockProps) {
  return (
    <pre
      data-crd-id="r2.bq-code-block"
      data-crd-layer="r2"
      className={`${styles.codeBlock} ${className ?? ''}`}
    >
      <code>{children}</code>
    </pre>
  );
}
